import {
	analyticsActionCauseList,
	ComponentOptions,
	IAnalyticsNoMeta,
	IComponentBindings,
	Initialization,
	InitializationEvents
} from 'coveo-search-ui';
import { RecentSearches } from "./RecentSearches";
import * as $ from 'jquery';
import { AtlasComponent } from "./../models/AtlasComponent";
import { SearchHelper } from "./../models/SearchHelper";

export class SimpleSearchbox extends AtlasComponent {
	static ID = 'SimpleSearchbox';
	static queryStateParam = "queryFilter";
	private $searchbox : JQuery;
	private searchHelper: SearchHelper = SearchHelper.Instance;

	get query() : string {
		return this.$searchbox.val();
	}

	set query(val) {
		this.$searchbox.val(val);
	};

	constructor(public element: HTMLElement, public options: ComponentOptions, bindings: IComponentBindings) {
		super(element, SimpleSearchbox.ID, bindings);
		this.options = ComponentOptions.initComponentOptions(element, SimpleSearchbox, options);
		this.$searchbox = $(".js-query-input", this.element);
		
		this.bind.onRootElement(InitializationEvents.afterComponentsInitialization, () => this.afterComponentsInitialization());
		$(".js-query-action", this.element).on("click", () => this.performSearch());
		this.$searchbox.on("keyup", (e) => { if (e.keyCode === 13) this.performSearch(); });
	}

	public performSearch() : void {
		this.queryStateModel.set(SimpleSearchbox.queryStateParam, this.query);
		this.usageAnalytics.logSearchEvent<IAnalyticsNoMeta>(analyticsActionCauseList.searchboxSubmit, {});
		this.queryController.executeQuery({
			searchAsYouType: false,
			logInActionsHistory: true
		});
		this.searchHelper.addSearchTerm(this.query);
	}

	private afterComponentsInitialization() {
		this.setQueryFromState();
	}

	private setQueryFromState() {
		var simpleSearchboxQuery = Coveo.HashUtils.getValue(SimpleSearchbox.queryStateParam, window.location.hash),
			globalSearchboxQuery =  Coveo.HashUtils.getValue("q", window.location.hash),
			query = simpleSearchboxQuery || globalSearchboxQuery || "";

		this.queryStateModel.registerNewAttribute(SimpleSearchbox.queryStateParam, query);
		this.query = query;
	}
}

Initialization.registerAutoCreateComponent(SimpleSearchbox);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/SimpleSearchbox.ts